import { addDoc, collection, doc } from "firebase/firestore";
import { db } from "../../../../firebase";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { storage } from "../../../../firebase";

export const createNewGuestCard = async (
  data,
  companyName,
  selectedPets,
  interest,
  filteredNotes,
  files
) => {
  const companiesRef = collection(db, "companies");
  const companyDocRef = doc(companiesRef, companyName);
  const guestRef = collection(companyDocRef, "guestCards");

  try {
    const values = { ...data };

    Object.keys(values).forEach((key) => {
      const value = values[key];
      if (value === undefined) {
        values[key] = "";
        // Convert Date to formatted string
      } else if (value instanceof Date) {
        values[key] = value.format("DD-MM-YYYY");
      }
    });

    const uniqueIds = {}; // Helper object to keep track of seen ids
    const imagesUrl = []; // Helper object to keep track of seen ids
    const uniqueItems = files.filter((item) => {
      // If the id is not in the uniqueIds object, add it and return true
      if (!uniqueIds[item.uid]) {
        uniqueIds[item.uid] = true;
        return true;
      }
      // If the id is already in the uniqueIds object, return false to filter it out
      return false;
    });

    for (const file of uniqueItems) {
      const storageRef = ref(storage, `/files/guestCards/${file.name}`);
      const uploadTask = uploadBytesResumable(storageRef, file);

      try {
        await uploadTask;

        // File uploaded successfully
        const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
        const fileData = {
          downloadURL: downloadURL,
          id: file.uid,
          name: file.name,
          type: file.type,
          isDefault: false,
        };
        imagesUrl.push(fileData);
        console.log("Download URL for", file.name, ":", downloadURL);
      } catch (error) {
        console.error("Upload error for", file.name, ":", error);
      }
    }

    console.log("files", files);
    console.log("imagesUrlimagesUrlimagesUrl", imagesUrl);

    await addDoc(guestRef, {
      guestContact: {
        firstName: values.firstName || "",
        middleInitial: values.middleInitial || "",
        lastName: values.lastName || "",
        email: values.email || "",
        phoneNumber: values.phoneNumber || "",
        source: values.source || "",
        assignTo: values.assignTo || "",
      },
      interests: interest,
      profile: {
        pets: selectedPets,
        numberOfBedRooms: values.numberOfBedRooms || "",
        bathrooms: values.bathrooms || "",
        maxRent: values.maxRent || "",
        moveInDate: values["moveInDate"]
          ? values["moveInDate"].format("DD-MM-YYYY")
          : "",
        additionalOccupants: values.additionalOccupants || "",
        monthlyIncome: values.monthlyIcom || "",
        creditStore: values.creditStore || "",
      },
      comments: values.comments,
      status: "",
      notes: filteredNotes,
      attachments: imagesUrl,
    });
  } catch (err) {
    console.error(err);
    alert(err.message);
  }
};
